module.exports = __webpack_public_path__ + "img/project_1.d6fa2f74.jpg";